import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 bg-brand-slate relative border-t border-brand-charcoal overflow-hidden" data-id="element-146">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-[100px] pointer-events-none" data-id="element-147" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-148">
        <FadeIn data-id="element-149">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-brand-cream" data-id="element-150">
            Recupera el mando de tu hogar hoy mismo.
          </h2>
          <p className="text-xl text-brand-gray mb-12" data-id="element-151">
            No esperes a que la distancia sea irreparable. Consigue "El Código
            del Silencio" por una fracción de lo que cuesta una sola sesión de
            terapia.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-152">
          <div className="bg-brand-navy border-2 border-brand-gold/30 rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto" data-id="element-153">
            <h3 className="text-2xl font-playfair text-brand-cream mb-2" data-id="element-154">
              Inversión Única
            </h3>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-155">
              <span className="text-3xl font-bold text-brand-gray/50 line-through" data-id="element-156">
                $27
              </span>
              <span className="text-6xl font-bold text-brand-gold" data-id="element-157">$6.39</span>
              <span className="text-xl text-brand-gray mt-4" data-id="element-158">USD</span>
            </div>
            <span className="inline-block bg-red-500/20 text-red-400 text-sm font-semibold px-4 py-1 rounded-full mb-8" data-id="element-159">
              🔥 76% DE DESCUENTO — OFERTA LIMITADA
            </span>

            <CTAButton text="SÍ, QUIERO RECUPERAR LA PAZ EN MI CASA" href="https://claridaddiaria.com/cart/43044425859138:1" className="w-full py-5 text-xl mb-6" data-id="element-160" />

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-brand-gray/80" data-id="element-161">
              <div className="flex items-center gap-2" data-id="element-162">
                <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-163" />
                <span data-id="element-164">Pago 100% seguro</span>
              </div>
              <span className="hidden sm:inline" data-id="element-165">•</span>
              <span data-id="element-166">Acceso instantáneo en PDF a tu correo</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}